<div class="tab-header-row" [class.collapse-horizontal]="collapseOrientation === 'horizontal'">
  <si-tabset>
    @for (tab of tabs; track tab.heading; let i = $index) {
    <si-tab [active]="tab.active ?? false"
      [closable]="tab.closable" [heading]="tab.heading" [icon]="tab.icon"
      (activeChange)="onTabActiveChange(i, $event)"
      (closeTriggered)="closeTab(tab)">
      <!-- Content will be projected here -->
    </si-tab>
    }
  </si-tabset>
  @if ((actions && actions.length > 0) || onToggleCollapse) {
    <div class="tab-actions">
      @for (action of actions; track $index) {
        <button
          type="button"
          class="btn btn-circle btn-sm btn-ghost"
          [attr.aria-label]="action.tooltip"
          [siTooltip]="action.tooltip"
          placement="bottom"
          [disabled]="action.disabled ?? false"
          (click)="action.click()">
          <si-icon [icon]="action.iconClass" />
        </button>
      }
      @if (onToggleCollapse) {
        <button
          type="button"
          class="btn btn-circle btn-sm btn-ghost collapse-toggle-btn"
          [attr.aria-label]="isCollapsed ? 'Expand panel' : 'Collapse panel'"
          [siTooltip]="isCollapsed ? 'Expand' : 'Collapse'"
          placement="bottom"
          (click)="onToggleCollapse()">
          <si-icon icon="element-double-right" [class.is-collapsed]="isCollapsed" />
        </button>
      }
    </div>
  }
</div>
<!-- Content projection area - render based on selected tab -->
<div class="tab-content-area">
  <ng-content></ng-content>
</div>